// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__A+kIW","logo":"MainNavigation_logo__AQtwn","active":"MainNavigation_active__A3hGx","badge":"MainNavigation_badge__YyHT7"};